import HttpMethods from "../../../Services/httpMethods";
import { makeRequest } from "../../../Services/restcall";
import { ApiResponse } from "../../../Services/types";
export async function PostOfertaAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.POST, '/api/commerce/create-oferta',value)
}
export async function updateOfertaAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.PUT, '/api/commerce/update-oferta', value)
}
export async function deleteOfertaAPI(id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.DELETE, '/api/commerce/delete-oferta', { id })
}
export async function getAllOfertasAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.GET, '/api/commerce/ofertas', {});
}
export async function getAllOfertasActivasAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.GET, '/api/commerce/activas', {});
}

export async function getOfertaByIdAPI(id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.GET, '/api/commerce/oferta-id', { id })
}


